export default {
  preloader: false,
  params: {
    date_generate: null
  },
  suggestedReplacement: []
}



// WEBPACK FOOTER //
// ./src/modules/suggested_replacement/state.js